import { ClientInput } from 'admin/inputs/ClientInput';
import { Create, getRecordFromLocation, NumberInput, SimpleForm, TextInput } from 'react-admin';
import { useLocation } from 'react-router-dom';

export const FinancialReserveCreate: React.FC = () => {
  const location = useLocation();
  const record = getRecordFromLocation(location);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const redirect = (basePath: any, id: any, data: any) => {
    return `Client/${data.client.id}/show/financialReserves`;
  };

  return (
    <Create redirect={redirect}>
      <SimpleForm>
        <ClientInput disabled={!!record?.clientId} label="Klient" source="clientId" />
        <TextInput label="Forma finančnej rezervy" source="text" sx={{ maxWidth: '40em', width: '100%' }} />
        <NumberInput label="Suma" required source="amount.amount" />
      </SimpleForm>
    </Create>
  );
};
